import React from 'react';
import withIconProps from './utils/withIconProps';

const SvgBoard = ({ title, ...props }) => (
  <svg viewBox="0 0 16 16" aria-labelledby="title" role="img" {...props}>
    {title ? <title>{title}</title> : null}
    <path d="M0 2.9h7.3v3H0zM8.7 2.9H16v3H8.7zM0 6.6V13h7.3V6.6H0zm6.3 5.5H1V7.6h5.3v4.5zM8.7 6.7v6.4H16V6.7H8.7zm6.3 5.5H9.6V7.7H15v4.5z" />
  </svg>
);

SvgBoard.displayName = 'Board';
export default withIconProps(SvgBoard);
